// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarJobs_container__RThDP","title":"SimilarJobs_title__p2vdH"};